import React, { Component } from 'react';
import "./FAQList.css";
import { QuestionAnwser } from "./QuestionAnwser";

export class QAGroups extends Component {
  state = { faq: null, collapse: false };

  componentWillMount() {
    this.setState({ faq: { ...this.props.faq } });
  }

  collapseToggle = () => {
    this.setState({ collapse: !this.state.collapse });
  };

  handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.collapseToggle();
    }
  };

  componentWillReceiveProps(nextProps, nextContext) {
    if(this.state.collapse){
      this.setState({ collapse: false });
    }
  }

  render() {
    const faq = this.state.faq;
    const collapse = this.state.collapse;
    const contentId = `faq-content-${faq.title.replace(/\s+/g, '-').toLowerCase()}`;

    const QuestionAnwserTemplate = faq.faq.map((qa, index) => {
      return(<QuestionAnwser key={`questionanwser-${index}`} qa={qa} isParentOpen={collapse}/>);
    });

    return(
        <div className="card">
          <div className="card-header">
            <h4>
              <button
                  type="button"
                  className="faq-group-button card-title standard-blue"
                  data-track="faq-links"
                  aria-expanded={collapse}
                  aria-controls={contentId}
                  onClick={this.collapseToggle}
                  onKeyDown={this.handleKeyDown}
              >
                <span className={`cl-arrow ${collapse ? "cl-arrow-down" : "cl-arrow-right"}`} aria-hidden="true"></span>
                {faq.title}
              </button>
            </h4>
          </div>
          <div id={contentId} className={`collapse ${collapse ? "show" : "hide"}`}>
            <div className="card-body">
              <ul className="list-group">
                {QuestionAnwserTemplate}
              </ul>
            </div>
          </div>
        </div>
    );
  }
}